///include /assets/js/app/p/checkout.js
class CheckoutRazorpay extends CheckoutDriver {
    get requiresImmediateSelection() {
        return false
    }
}

CheckoutDriver.byName.razorpay = CheckoutRazorpay
